/** Maps to TalentToolbox.Forms.Core.Enums.WindowDatabaseStatus */
export enum WindowDatabaseStatusEnum {
  Exists,
  ToAdd,
  ToUpdate,
  ToDelete
}

export default WindowDatabaseStatusEnum;
